<template>
	<div v-if="showPopup && images.length" class="popup-overlay_main_pop">
		<div class="popup-content_main_pop" :class="{ 'is-pc': isPc, 'is-mo': !isPc }">
			<button @click="closePopup" class="close-btn">&times;</button>
			<swiper :spaceBetween="30" :centeredSlides="true" :autoplay="{
				delay: 2500,
				disableOnInteraction: false,
			}" :pagination="{
				clickable: true,
			}" :navigation="true" :modules="modules" class="mySwiper mainPop">
				<swiper-slide v-for="(item, index) in images" :key="index">
					<a href="#" @click.prevent="handleImageClick(item)" rel="noopener noreferrer">
						<img :src="item.src" alt="Popup Image" />
					</a>
				</swiper-slide>
			</swiper>
			<!-- 추가된 버튼들 -->
			<!-- <button @click="hideForOneWeek" class="hide-btn"> 일주일간 보지않기 </button> -->
			<button @click="hideForToday" class="hide-btn">오늘은 보지않기</button>
			<span style="vertical-align: sub">┃</span>
			<button @click="closePopup" class="hide-btn">닫기</button>
		</div>

	</div>
</template>

<script>
import { ref, onMounted, onBeforeUnmount } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Autoplay, Pagination, Navigation } from "swiper/modules";

export default {
	components: {
		Swiper,
		SwiperSlide,
	},
	props: {
		images: {
			type: Array,
			required: true,
		},
	},
	emits: ['click'],
	data() {
		return {
			showPopup:
				!localStorage.getItem("hidePopupUntil") ||
				new Date() > new Date(localStorage.getItem("hidePopupUntil")),
		};
	},
	methods: {
		handleImageClick(item) {
			this.$emit('click', item);
			this.closePopup();
		},
		closePopup() {
			this.showPopup = false;
		},
		hideForOneWeek() {
			const futureDate = new Date();
			futureDate.setDate(futureDate.getDate() + 7);
			localStorage.setItem("hidePopupUntil", futureDate);
			this.showPopup = false;
		},
		hideForToday() {
			const futureDate = new Date();
			futureDate.setHours(23, 59, 59, 999);
			localStorage.setItem("hidePopupUntil", futureDate);
			this.showPopup = false;
		},
	},
	setup() {
		const isPc = ref(false);

		const updateIsPc = () => {
			if (window.innerWidth > 768) {
				isPc.value = true;
			} else {
				isPc.value = false;
			}
			console.log("isPc:", isPc.value); // 확인을 위해 추가
		};

		onMounted(() => {
			updateIsPc();
			window.addEventListener("resize", updateIsPc);
		});

		onBeforeUnmount(() => {
			window.removeEventListener("resize", updateIsPc);
		});

		return {
			isPc,
			modules: [Autoplay, Pagination, Navigation],
		};
	},
};
</script>

<style scoped>
.popup-overlay_main_pop {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 99999;
}

.popup-content_main_pop {
	background: white;
	padding: 15px 15px 10px 15px;
	/* 좌/우/상단 5px, 하단 0 */
	border-radius: 12px;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	text-align: center;
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
	z-index: 10000;
	width: 90vw;
	max-width: 540px;
	/* PC에서 최대 480px */
	min-width: 280px;
	overflow: hidden;
	/* 이미지 라운드 처리 */
}

.popup-content_main_pop.is-pc {
	max-width: 540px;
	/* PC 화면에서 적용되는 너비 */
}

.popup-content_main_pop.is-mo {
	max-width: 95vw;
	/* 모바일 화면에서 적용되는 너비 */
}

.swiper {
	width: 100%;
	height: 100%;
}

.swiper-slide {
	background: #fff;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 0;
	height: auto;
}

.swiper-slide img {
	display: block;
	width: 100%;
	height: auto;
	object-fit: cover;
	border-radius: 0;
}

.swiper-button-next,
.swiper-button-prev {
	color: #000;
	width: 48px;
	height: 48px;
	top: 50% !important;
	transform: translateY(-50%);
}

.swiper-button-next {
	right: 10px !important;
}

.swiper-button-prev {
	left: 10px !important;
}

.swiper-button-next:after,
.swiper-button-prev:after {
	font-size: 32px;
}

.close-btn {
	position: absolute;
	top: 10px;
	right: 15px;
	background: none;
	border: none;
	font-size: 35px;
	cursor: pointer;
	z-index: 10001;
}

.hide-btn {
	position: relative;
	top: 5px;
	margin: 10px;
	background: none;
	border: none;
	font-size: 16px;
	cursor: pointer;
	transition: color 0.3s ease;
}

.close-btn:hover,
.hide-btn:hover {
	color: red;
}
</style>
